import {ChangeDetectorRef, Component, ElementRef, forwardRef, Input} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractMultiselectInput} from "../abstract-multiselect-input";
import {FUIEventsService} from "../../../../events/events.service";import {FUIOptionsService} from "../../../framework/options.service";

@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUIEditMultiselectInputComponent),
            multi: true
        }
    ],
    selector: "fui-edit-multiselect-input",
    styleUrls: ["../multiselect-input.scss"],
    templateUrl: "./edit-multiselect-input.component.html"
})
export class FUIEditMultiselectInputComponent extends FUIAbstractMultiselectInput {
    @Input() allowLabelMarkup: boolean = false;

    constructor(changeDetectorRef: ChangeDetectorRef,
                elementRef: ElementRef,
                eventsService: FUIEventsService,
                optionsService: FUIOptionsService) {
        super(changeDetectorRef, elementRef, eventsService, optionsService);
    }
}
